/* unplugin-vue-components disabled */import i18n from '@/lang';
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Tabbar from "vux/src/components/tabbar/tabbar.vue"; // this line is trasformed by vux-loader
import TabbarItem from "vux/src/components/tabbar/tabbar-item.vue"; // this line is trasformed by vux-loader
export default {
  name: 'BottomBar',
  components: {
    Tabbar: Tabbar,
    TabbarItem: TabbarItem
  },
  data: function data() {
    return {
      tabbarButton: [{
        title: i18n.tc("0"),
        routerName: 'Home',
        icon: '/spa_static_mobile/icon/homePage/nohome40_40@3x.png',
        iconActive: '/spa_static_mobile/icon/homePage/home40_40@3x.png'
      }, {
        title: i18n.tc("346"),
        routerName: 'Project',
        icon: '/spa_static_mobile/icon/homePage/noorder32_40@3x.png',
        iconActive: '/spa_static_mobile/icon/homePage/order32_40@3x.png'
      }, {
        title: i18n.tc("119"),
        routerName: 'Mine',
        icon: '/spa_static_mobile/icon/homePage/nomine40_40@3x.png',
        iconActive: '/spa_static_mobile/icon/homePage/mine40_40@3x.png'
      }]
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user'])),
  methods: {
    // 菜单权限控制
    menuControll: function menuControll(routerName) {
      return true;
    }
  }
};